export default {
  "b2b.zadosti-odsouhlasene-widget.label": "Odsouhlasené žádosti",
  "b2b.zadosti-odsouhlasene-widget.message-empty": "Žádné odsouhlasené žádosti"
};
